import asyncComponent from 'util/asyncComponent'

export const adminRoutes = [
  {
   path: '/admin/impersonate/:id',
   component: asyncComponent(() => import('../Linkgua/containers/Admin/Impersonate'))
  }
]



// WEBPACK FOOTER //
// ./app/adminRoutes.js